var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card table-card" }, [
    _c("div", { staticClass: "table-tools" }, [
      _c("h3", [
        _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.cityDetailTitle"))),
      ]),
      _c(
        "div",
        { staticClass: "table-actions" },
        [
          _c("el-input", {
            staticClass: "search-input",
            attrs: {
              placeholder: _vm.$t(
                "collectionOperationDashboard.searchPlaceholder"
              ),
              clearable: "",
              "prefix-icon": "el-icon-search",
              size: "small",
            },
            on: { clear: _vm.handleKeywordSearch },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.handleKeywordSearch($event)
              },
            },
            model: {
              value: _vm.keyword,
              callback: function ($$v) {
                _vm.keyword = $$v
              },
              expression: "keyword",
            },
          }),
          _c(
            "el-button",
            {
              staticClass: "export-btn",
              attrs: { size: "small" },
              on: { click: _vm.handleExport },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("collectionOperationDashboard.exportCsv")) +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "table-wrap" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: { data: _vm.tableData, height: "470", stripe: "" },
          },
          [
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("GlobalSetObj.client"),
                "min-width": "100",
                prop: "platform",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("span", { staticClass: "client-name" }, [
                        _vm._v(_vm._s(_vm.formatPlatform(row))),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "UF", prop: "stateCode", width: "80" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      row.stateCode
                        ? _c("span", { staticClass: "uf-chip" }, [
                            _vm._v(_vm._s(row.stateCode)),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("collectionCenter.city"),
                "min-width": "180",
                prop: "cityName",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("span", { staticClass: "city-name" }, [
                        _vm._v(_vm._s(row.cityName || "")),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("collectionOperationDashboard.collectVolume"),
                align: "right",
                prop: "collectTotal",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("span", { staticClass: "cell-num" }, [
                        _vm._v(_vm._s(_vm.formatNumber(row.collectTotal))),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("collectionOperationDashboard.loadedTotal"),
                align: "right",
                prop: "loadedTotal",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("span", { staticClass: "cell-num" }, [
                        _vm._v(_vm._s(_vm.formatNumber(row.loadedTotal))),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("collectionOperationDashboard.unloadedTotal"),
                align: "right",
                prop: "unloadedTotal",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("span", { staticClass: "cell-num" }, [
                        _vm._v(_vm._s(_vm.formatNumber(row.unloadedTotal))),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("collectionCenter.CollectionRate"),
                align: "right",
                prop: "collectRate",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _vm.formatRate(row)
                        ? _c(
                            "span",
                            { staticClass: "rate", class: _vm.rateClass(row) },
                            [
                              _c("i", {
                                staticClass: "dot",
                                class: _vm.rateClass(row),
                              }),
                              _vm._v(" " + _vm._s(_vm.formatRate(row)) + " "),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "pager" },
      [
        _vm.keyword
          ? _c("span", { staticClass: "filter-tip" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("collectionOperationDashboard.keywordFiltered", {
                      keyword: _vm.keyword,
                      count: _vm.queryForm.total,
                    })
                  ) +
                  " "
              ),
            ])
          : _vm._e(),
        _c("el-pagination", {
          staticStyle: { margin: "10px 0", float: "right" },
          attrs: {
            "current-page": _vm.queryForm.pageNumber,
            "page-size": _vm.queryForm.pageSize,
            "page-sizes": [10, 20, 50, 100],
            total: _vm.queryForm.total,
            background: "",
            layout: "total, sizes, prev, pager, next, jumper",
          },
          on: {
            "size-change": _vm.handleSizeChange,
            "current-change": _vm.handleCurrentChange,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }